import { render, staticRenderFns } from "./AgeSelectionScreen.vue?vue&type=template&id=cc022354&"
import script from "./AgeSelectionScreen.vue?vue&type=script&lang=js&"
export * from "./AgeSelectionScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports